import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_IDEAL_ERROR: MijnRoute = {
    path: 'fout',
    navigationEvent: 'toIdealZelfserviceError',
    regex: /^\/zelf-regelen\/ideal\/fout$/,
    webcomponent: 'mijn-ideal-zelfservice-webcomponent',
    internalPath: '/fout'
};
